var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-lg mb-3",attrs:{"elevation":"4","outlined":""}},[_c('v-card-title',[_vm._v("Admin Dashboard")]),_c('v-divider'),_c('v-card-text',[_vm._v(" Admins eyes only! ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }